import React from 'react'
import { ReactComponent as FlashIcon } from './icons/flash.svg'

// Score View Icon with currentColor
const ScoreViewIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className={className}
  >
    <path
      d="M18.05 8.69992L17.2333 12.1833C16.5333 15.1916 15.15 16.4083 12.55 16.1583C12.1333 16.1249 11.6833 16.0499 11.2 15.9333L9.79999 15.5999C6.32499 14.7749 5.24999 13.0583 6.06665 9.57493L6.88332 6.08326C7.04999 5.37493 7.24999 4.75826 7.49999 4.24993C8.47499 2.23326 10.1333 1.69159 12.9167 2.34993L14.3083 2.67493C17.8 3.49159 18.8667 5.21659 18.05 8.69992Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.55 16.1583C12.0334 16.5083 11.3834 16.8 10.5917 17.0583L9.27504 17.4917C5.96671 18.5583 4.22504 17.6667 3.15004 14.3583L2.08337 11.0667C1.01671 7.75833 1.90004 6.00833 5.20837 4.94167L6.52504 4.50833C6.86671 4.4 7.19171 4.30833 7.50004 4.25C7.25004 4.75833 7.05004 5.375 6.88337 6.08333L6.06671 9.575C5.25004 13.0583 6.32504 14.775 9.80004 15.6L11.2 15.9333C11.6834 16.05 12.1334 16.125 12.55 16.1583Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5334 7.1084L14.5751 8.1334"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.71655 10.3333L12.1332 10.9499"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

// Helper for image icon color filter
const getImageFilter = (active) =>
  active
    ? 'invert(1) brightness(2)' // white
    : 'invert(34%) sepia(0%) saturate(0%) hue-rotate(180deg) brightness(92%) contrast(88%)' // grey

const tabs = [
  {
    id: 'score-view',
    label: 'Score View',
    icon: ScoreViewIcon,
  },
  {
    id: 'english',
    label: 'English',
    iconSrc:
      'https://cdn.builder.io/api/v1/image/assets/d84e059b57274e6aae99b9cca7cfff8b/4ffe6046b730fe588fcfdf85ca843642c742bb8c?placeholderIfAbsent=true',
  },
  {
    id: 'mathematics',
    label: 'Mathematics',
    iconSrc:
      'https://cdn.builder.io/api/v1/image/assets/d84e059b57274e6aae99b9cca7cfff8b/816b5a129f8b6899a6be68d9218633be2ccddf9d?placeholderIfAbsent=true',
  },
  {
    id: 'reading',
    label: 'Reading',
    iconSrc:
      'https://cdn.builder.io/api/v1/image/assets/d84e059b57274e6aae99b9cca7cfff8b/da8541a0d9cbb96a0520d307387468ce0031f1fa?placeholderIfAbsent=true',
  },
  {
    id: 'science',
    label: 'Science',
    iconSrc:
      'https://cdn.builder.io/api/v1/image/assets/d84e059b57274e6aae99b9cca7cfff8b/c9a5abe970a7cd5879a34622e65bfa93e0d1c0e9?placeholderIfAbsent=true',
  },
  {
    id: 'strength-weakness',
    label: 'Strengths & Weaknesses',
    icon: FlashIcon,
  },
]

const ScoreTabs = ({ activeTab, onTabChange, tabs: customTabs }) => {
  const tabList = customTabs || tabs
  return (
    <div className="items-center border border-[#F0F0F0] flex text-sm text-[#535862] text-center tracking-[-0.35px] leading-none flex-wrap mt-3 p-1 rounded-[10px] border-solid">
      {tabList.map((tab) => {
        const isActive = activeTab === tab.id
        const color = isActive ? '#FAFAFA' : '#535862'
        return (
          <div
            key={tab.id}
            className={`justify-center items-center self-stretch flex gap-1.5 ${
              isActive
                ? 'text-neutral-50 bg-[#DE3C7D] rounded-lg'
                : 'text-[#535862]'
            } px-4 py-2 cursor-pointer`}
            onClick={() => onTabChange(tab.id)}
          >
            {tab.icon ? (
              // SVG icon as component
              React.createElement(tab.icon, {
                className: 'self-stretch flex w-5 shrink-0 h-5 my-auto',
                style: { color },
              })
            ) : (
              // Image icon
              <img
                src={tab.iconSrc}
                className="aspect-[1] object-contain w-5 self-stretch shrink-0 my-auto"
                alt={tab.label}
                style={{ filter: getImageFilter(isActive) }}
              />
            )}
            <div
              className={`self-stretch min-h-5 my-auto ${
                isActive ? 'text-neutral-50' : 'text-[#535862]'
              }`}
            >
              {tab.label}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default ScoreTabs
